<template>
    <div id="custom-intercom" @click="requestIntercom" :class="{ 'is-mobile': isMobile }">
        <icon name="ci-intercom" scale="1" />

        <h6>{{ $t('Components_Utils_CustomIntercom_1') }}</h6>

        <span v-if="unreadMessages > 0" class="badge">
            {{ unreadMessages }}
        </span>
    </div>
</template>
<script>
export default {
    name: 'CustomIntercom',
    data() {
        return {
            unreadMessages: 0,
            isMobile: false,
            hideInterval: null,
        }
    },
    methods: {
        /**
         * Summary.
         * This method opens the Intercom laucher on the custom element click event
         */
        requestIntercom() {
            this.stopsHideInterval()

            // let intercomElement = document.querySelector('.intercom-lightweight-app')
            //                         || document.querySelector('.intercom-container')
            //                         || document.querySelector('.intercom-launcher-frame')
            // if(intercomElement){
            //     intercomElement.classList.remove('d-none')
            // }

            window.Intercom('show')
        },

        /**
         * Summary.
         * This method verify when the Intercom Launcher is available so we can hide it.
         */
        hideIntercom() {
            let intercomElement = null
            let interval = setInterval((_) => {
                intercomElement =
                    document.querySelector('.intercom-lightweight-app') ||
                    document.querySelector('.intercom-container') ||
                    document.querySelector('.intercom-launcher-frame') ||
                    document.querySelector('.intercom-app')
                if (intercomElement) {
                    intercomElement.classList.add('d-none')
                    clearInterval(interval)
                }
            }, 200)
        },

        startsHideInterval() {
            // Sometimes intercom appears randonly on user's screen.
            // This interval is used to avoid it.
            this.hideInterval = setInterval((_) => {
                this.hideIntercom()
            }, 15000)
        },

        stopsHideInterval() {
            clearInterval(this.hideInterval)
            this.hideInterval = null
        },
    },
    mounted() {
        this.startsHideInterval()
        this.hideIntercom()

        window.Intercom('onHide', () => {
            setTimeout(() => {
                this.hideIntercom()
                this.startsHideInterval()
            }, 2000)
        })

        window.Intercom('onUnreadCountChange', (total) => {
            this.unreadMessages = total
        })

        this.isMobile = this.$Mobile.verify()
    },
}
</script>
<style lang="scss">
@import '@/scss/components/Utils/custom-intercom.scss';
</style>
